import type { FC } from 'react';
import { useTheme } from '@mui/material/styles';

export const Logo: FC = () => {
  const theme = useTheme();
  const fillColor = theme.palette.primary.main;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 59 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.6747 13.0995L46.3218 22.4019C41.901 16.4559 34.2666 14.0538 27.2643 16.3988C20.262 18.7438 15.5884 25.273 15.5925 32.6953C15.5966 40.1217 20.2784 46.6428 27.2847 48.9796C34.2911 51.3164 41.9173 48.9062 46.334 42.9561L58.6992 52.2422C50.3429 63.5021 35.6818 68.1349 22.4276 63.7101C9.1734 59.2852 0.168715 46.7529 0.160559 32.7035C0.152402 18.654 9.1367 6.10947 22.3868 1.66831C25.7024 0.559032 29.1036 0.0166306 32.4722 0.000317788C42.578 -0.0445425 52.3983 4.66171 58.6747 13.0995Z"
        fill={fillColor}
      />
    </svg>
  );
};
